import { defineStore } from 'pinia';

import {getPermissios} from '../utils/dict'
import {getPermissioss} from '../business/Computer.js'
export const usePermissions = defineStore('Permissions', {
    state: () => {
        return {
            Permissions: [],
            _map:{},
            dataScope:{},
            roleItem:[],
            menuItem:{}
        }
    },
    actions: {
        setPermissions(data) {
            this.roleItem=data
            let Permissions=getPermissios(data,'')
            this.menuItem =getPermissioss(data,'')
            this.Permissions=Permissions.map(it=>{
                return  it.replace(/\s+/g,"");
            })
            this.Permissions.forEach(ele => {
                this._map[ele]=1
            });
        },
        setDataScope(data){
            this.dataScope=JSON.parse(JSON.stringify(data))
        }
    }
})